import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function TermsPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-699" data-mp="2k7wy1anubky7">
      <Navigation data-id="element-700" data-mp="2f9lrp9wr7skq" />

      <div className="pt-32 pb-20 px-4" data-id="element-701" data-mp="2t6qvf38zwfct">
        <div className="max-w-4xl mx-auto" data-id="element-702" data-mp="2t5peii5asyn6">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-703" data-mp="2o7xcuweupy5s">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-704" data-mp="2xyiiv4wuu4yq">
              Terms of{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-705" data-mp="37ttsx9xbio05">
                Service
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-706" data-mp="2zp2t5erwmdbb">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <div className="space-y-8" data-id="element-707" data-mp="3imltzv47kpmn">
              <Section title="1. Agreement to Terms" data-id="element-708" data-mp="3ilkfthrwbn0p">
                <p data-id="element-709" data-mp="3nfewecc7flvk">
                  By accessing or using Jetly Agency's services, you agree to be
                  bound by these Terms of Service. If you disagree with any part
                  of these terms, you may not use our services.
                </p>
              </Section>

              <Section title="2. Services Description" data-id="element-710" data-mp="65gw1y15pz8h">
                <p data-id="element-711" data-mp="63w0c533wa91">
                  Jetly Agency provides professional web design and development
                  services, including:
                </p>
                <ul data-id="element-712" data-mp="37pqnfk5hmsoy">
                  <li data-id="element-713" data-mp="37q8rh2ye6b7f">Free website demo creation</li>
                  <li data-id="element-714" data-mp="3mdtrup3vtwbn">Custom website design and development</li>
                  <li data-id="element-715" data-mp="3mf4zj00g7o81">Website hosting setup assistance</li>
                  <li data-id="element-716" data-mp="3hltosnsimnau">30 days of post-launch support</li>
                </ul>
              </Section>

              <Section title="3. Pricing and Payment" data-id="element-717" data-mp="3vcp006qhlghl">
                <p data-id="element-718" data-mp="3qf5nbb9ftbrr">
                  <strong data-id="element-719" data-mp="3qfot5tltc9pf">Free Demo:</strong> We provide a free website demo
                  with no obligation. You only pay if you approve the design and
                  want to launch.
                </p>
                <p data-id="element-720" data-mp="48qnx7pnjqct">
                  <strong data-id="element-721" data-mp="488gdexjhppl">Professional Package (€299):</strong> One-time payment
                  for complete website. Payment required after demo approval
                  before final launch.
                </p>
                <p data-id="element-722" data-mp="26152bwszmcoh">
                  <strong data-id="element-723" data-mp="lh190exo7ka1">Hosting (€10/month):</strong> Optional hosting and
                  maintenance service.
                </p>
                <p data-id="element-724" data-mp="qf2sh0z0dlm1">
                  All prices are in Euros (EUR). Payments are non-refundable
                  once work has commenced.
                </p>
              </Section>

              <Section title="4. Project Timeline" data-id="element-725" data-mp="gprkjhnuymzq">
                <p data-id="element-726" data-mp="goggdgqi3d83">
                  Standard projects are completed within 24 hours from demo
                  approval. Timeline may vary based on:
                </p>
                <ul data-id="element-727" data-mp="6swpx9uph6qq">
                  <li data-id="element-728" data-mp="6tga6x7tw77x">Project complexity</li>
                  <li data-id="element-729" data-mp="3oy9q2wkkqg3p">Client feedback response time</li>
                  <li data-id="element-730" data-mp="3ozkw731hrzxz">Content availability</li>
                </ul>
              </Section>

              <Section title="5. Revisions and Changes" data-id="element-731" data-mp="3tx34qsblkd5g">
                <p data-id="element-732" data-mp="1n5v7rwe4b9mr">
                  Our package includes 3 rounds of revisions. Additional
                  revisions may incur extra charges. Major scope changes after
                  approval may require additional fees.
                </p>
              </Section>

              <Section title="6. Intellectual Property" data-id="element-733" data-mp="3j9i570dozihw">
                <p data-id="element-734" data-mp="3ja1czo9moqi7">
                  Upon full payment, you own all rights to the final website
                  design and code. Before payment, all work remains property of
                  Jetly Agency.
                </p>
              </Section>

              <Section title="7. Client Responsibilities" data-id="element-735" data-mp="359guyubjeypr">
                <p data-id="element-736" data-mp="35b1oqhq12dmk">Clients are responsible for:</p>
                <ul data-id="element-737" data-mp="30iidvsiq5wlg">
                  <li data-id="element-738" data-mp="30i8itqitoz8w">Providing accurate content and materials</li>
                  <li data-id="element-739" data-mp="2vjnrkgljtpwl">Timely feedback and approvals</li>
                  <li data-id="element-740" data-mp="2vk7056pb71xy">
                    Domain registration and hosting (if not using our services)
                  </li>
                  <li data-id="element-741" data-mp="2mj95vg4oa8sk">Compliance with applicable laws</li>
                </ul>
              </Section>

              <Section title="8. Limitation of Liability" data-id="element-742" data-mp="2hk5y3nxb5ogw">
                <p data-id="element-743" data-mp="2hko59flidn3l">
                  Jetly Agency is not liable for indirect, incidental, or
                  consequential damages arising from use of our services. Our
                  total liability is limited to the amount paid for services.
                </p>
              </Section>

              <Section title="9. Termination" data-id="element-744" data-mp="170t3uzd5htyq">
                <p data-id="element-745" data-mp="1b1mrdrmol6r3">
                  Either party may terminate the agreement with written notice.
                  Payments for completed work are non-refundable.
                </p>
              </Section>

              <Section title="10. Contact" data-id="element-746" data-mp="ja76c20rvs2z">
                <p data-id="element-747" data-mp="jb8m2jsqh2r1">For questions about these Terms, contact us at:</p>
                <p data-id="element-748" data-mp="nc29lc29kfje">
                  Email: legal@jetly.agency
                  <br data-id="element-749" data-mp="s30qacr5zfn6" />
                  Telegram: @jetlyagency
                </p>
              </Section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-750" data-mp="3rqa51i9wq6f6" />
      <CookieBanner data-id="element-751" data-mp="3ropj2h1nrvsx" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-752" data-mp="12wvfozf8q9m1">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-753" data-mp="1cn6x9orukhbe">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-754" data-mp="17qghz3nv9pr1">
        {children}
      </div>
    </div>;
}